let socket = null;
let lockReconnect = false; // 重连锁
let timeout = null; // 重连定时器
let heartTimer = null; // 心跳定时器
let currentUserId = null;
let manualClose = false; // 主动关闭时禁止自动重连
let socketGeneration = 0; // 连接世代，忽略旧连接回调
// const SOCKET_URL = 'ws://106.15.73.171:6320/'; //本地
// const SOCKET_URL = 'wss://xwd.juneng.yun/'; // 信维达
const SOCKET_URL = 'wss://ml.juneng.yun/'; // 麦力

// 心跳配置（必须加，否则后端会断开）
const HEART_BEAT_INTERVAL = 25000; // 25秒发一次心跳（与注释一致，避免 1s 频繁唤醒主线程）
const HEART_BEAT_MSG = 'yes';

function getStoredUserId() {
  return localStorage.getItem('userId');
}

function isSameUser(a, b) {
  if (a == null || b == null || a === '' || b === '') return false;
  return String(a) === String(b);
}

function teardownSocket() {
  const old = socket;
  socket = null;
  stopHeartBeat();
  clearTimeout(timeout);
  timeout = null;
  if (!old) return;
  old.onopen = null;
  old.onmessage = null;
  old.onerror = null;
  old.onclose = null;
  try {
    if (old.readyState === WebSocket.OPEN || old.readyState === WebSocket.CONNECTING) {
      old.close();
    }
  } catch (e) {}
}

// 创建连接：先销毁旧实例，再按当前 userId 新建
export function createWebSocket(userId) {
  const nextId = userId || getStoredUserId();
  if (!nextId) {
    console.log('WebSocket 无法连接：userId 为空');
    return;
  }

  teardownSocket();
  manualClose = false;
  lockReconnect = false;
  currentUserId = nextId;

  const wsUrl = SOCKET_URL + `admin-api/ws/${currentUserId}`;
  const generation = ++socketGeneration;

  try {
    socket = new WebSocket(wsUrl);
    initEvent(socket, generation);
  } catch (e) {
    console.log('连接异常', e);
    reconnect();
  }
}

// 初始化事件
function initEvent(ws, generation) {
  ws.onopen = () => {
    if (ws !== socket || generation !== socketGeneration || manualClose) return;
    console.log('✅ WebSocket 连接成功');
    lockReconnect = false;
    startHeartBeat();
  };

  ws.onmessage = (msg) => {
    if (ws !== socket || generation !== socketGeneration || manualClose) return;
    if (!isSameUser(currentUserId, getStoredUserId())) {
      closeWebSocket();
      return;
    }

    // 后端心跳：isOnline → 必须回复 yes
    if (msg.data === 'isOnline') {
      sendMessage(HEART_BEAT_MSG);
      return;
    }

    // 业务消息
    try {
      const data = msg.data;
      window.dispatchEvent(new CustomEvent('wsMessage', { detail: data }));
    } catch (e) {}
  };

  ws.onclose = (e) => {
    if (ws !== socket && socket !== null) return;
    if (generation !== socketGeneration) return;
    console.log('❌ WebSocket 断开', e, e.reason);
    stopHeartBeat();
    if (manualClose) return;
    reconnect();
  };

  ws.onerror = (err) => {
    if (ws !== socket || generation !== socketGeneration || manualClose) return;
    console.log('⚠️ WebSocket 出错', err);
    stopHeartBeat();
    reconnect();
  };
}

// 启动心跳（关键！防止后端断开）
function startHeartBeat() {
  stopHeartBeat();
  heartTimer = setInterval(() => {
    if (manualClose) return;
    if (socket && socket.readyState === 1) {
      socket.send(HEART_BEAT_MSG);
    }
  }, HEART_BEAT_INTERVAL);
}

// 停止心跳
function stopHeartBeat() {
  clearInterval(heartTimer);
  heartTimer = null;
}

// 重连
function reconnect() {
  if (manualClose) return;
  if (lockReconnect) return;
  if (!currentUserId || !isSameUser(currentUserId, getStoredUserId())) return;

  lockReconnect = true;
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    if (manualClose || !currentUserId || !isSameUser(currentUserId, getStoredUserId())) {
      lockReconnect = false;
      return;
    }
    createWebSocket(currentUserId);
    lockReconnect = false;
  }, 3000);
}

// 发送消息
export function sendMessage(data) {
  if (!socket || socket.readyState !== 1) return;
  if (!isSameUser(currentUserId, getStoredUserId())) return;

  if (typeof data === 'string') {
    socket.send(data);
  } else {
    socket.send(JSON.stringify(data));
  }
}

// 关闭连接（用户退出时调用）
export function closeWebSocket() {
  manualClose = true;
  currentUserId = null;
  lockReconnect = true;
  socketGeneration += 1;
  teardownSocket();
}

/** 登录成功：先清旧实例，再按新 userId 建连 */
export function resetWebSocket(userId) {
  closeWebSocket();
  if (!userId) return;
  createWebSocket(userId);
}

export default {
  createWebSocket,
  sendMessage,
  closeWebSocket,
  resetWebSocket,
};
